// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import '@/utils/request'
import VueBlu from 'vue-blu'
import 'vue-blu/dist/css/vue-blu.min.css'
import Pagination from 'vue-pagination-2'
import App from './App'
import router from './router'
Vue.component('pagination', Pagination)
import ElementUI from 'element-ui'
// import { Message } from 'element-ui'
// Vue.prototype.$message = Message
import 'element-ui/lib/theme-chalk/index.css'
import Carousel3d from 'vue-carousel-3d';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import './styles/global.css' /*引入公共样式*/
Vue.use(VueAwesomeSwiper);
Vue.use(Carousel3d);
Vue.use(ElementUI)
Vue.use(VueBlu)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js